"use client";

import { type RefObject, useEffect, useRef } from "react";
import { scheduleOnboardingWelcomeEntrance } from "./scheduleOnboardingWelcomeEntrance";
import type { OnboardingWelcomeGsapTimeline } from "./runOnboardingWelcomeEntrance";

/**
 * 在容器挂载且 `play === true` 时启动 HTML 同款 GSAP 时间轴
 */
export const useOnboardingWelcomeGsap = (
  containerRef: RefObject<HTMLElement | null>,
  ctaRef: RefObject<HTMLButtonElement | null>,
  targetCount: number,
  play: boolean,
): void => {
  const timelineRef = useRef<OnboardingWelcomeGsapTimeline | null>(null);

  useEffect(() => {
    if (!play) {
      return;
    }

    const cancelSchedule = scheduleOnboardingWelcomeEntrance(
      containerRef,
      ctaRef,
      targetCount,
      (timeline) => {
        timelineRef.current?.kill();
        timelineRef.current = timeline;
      },
    );

    return () => {
      cancelSchedule();
      timelineRef.current?.kill();
      timelineRef.current = null;
    };
  }, [play, targetCount, containerRef, ctaRef]);
};
